import React from 'react';
import { ShieldCheck, Truck, Star, Lock, BadgeCheck, MapPin } from 'lucide-react';

const BADGES = [
  {
    icon: BadgeCheck,
    title: '100% Authentic',
    desc: 'Hand-picked, temple-grade puja items sourced directly from artisans.',
    iconColor: 'text-emerald-600',
    bg: 'bg-emerald-50',
  },
  {
    icon: ShieldCheck,
    title: 'Made in India',
    desc: 'Proudly Indian — supporting local craftsmen across Bengal, UP & Tamil Nadu.',
    iconColor: 'text-orange-600',
    bg: 'bg-orange-50',
  },
  {
    icon: Truck,
    title: 'Free Shipping ₹500+',
    desc: 'Fast 3–5 day pan-India delivery on every pre-paid order.',
    iconColor: 'text-blue-600',
    bg: 'bg-blue-50',
  },
  {
    icon: Lock,
    title: 'Secure Payments',
    desc: 'UPI & bank transfer. Every transaction is verified before dispatch.',
    iconColor: 'text-violet-600',
    bg: 'bg-violet-50',
  },
  {
    icon: Star,
    title: '5★ Customer Rated',
    desc: 'Loved by 500+ devotees across India for quality and timely service.',
    iconColor: 'text-yellow-500',
    bg: 'bg-yellow-50',
  },
  {
    icon: MapPin,
    title: 'Pan-India Delivery',
    desc: 'We ship to 25,000+ pincodes — from Howrah to the Himalayas.',
    iconColor: 'text-rose-600',
    bg: 'bg-rose-50',
  },
];

export const WhyChooseUs = () => (
  <section data-testid="why-choose-us" className="py-16 bg-gradient-to-b from-white to-orange-50/40">
    <div className="max-w-7xl mx-auto px-4">
      <div className="text-center mb-12">
        <p className="uppercase tracking-widest text-xs text-orange-600 font-semibold mb-2">
          Why Sanatanbhavan
        </p>
        <h2 className="text-3xl md:text-4xl font-bold text-orange-900">
          Trusted by Thousands of Devotees
        </h2>
        <p className="text-gray-600 mt-3 max-w-2xl mx-auto">
          Every puja item we sell is hand-selected for purity, authenticity and traditional craftsmanship.
        </p>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-3 gap-6">
        {BADGES.map((b) => (
          <div
            key={b.title}
            data-testid={`badge-${b.title.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '')}`}
            className="bg-white rounded-2xl border border-orange-100 p-6 hover:shadow-md transition group"
          >
            <div className={`w-14 h-14 ${b.bg} rounded-xl flex items-center justify-center mb-4 group-hover:scale-105 transition`}>
              <b.icon className={b.iconColor} size={28} />
            </div>
            <h3 className="font-semibold text-lg text-gray-900 mb-1">{b.title}</h3>
            <p className="text-sm text-gray-600 leading-relaxed">{b.desc}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);
